<template>
  <div class="btn btn-secondary sort-button w-full text-left">
    <simple-select v-model="filterTemplate"
                   v-if="filterTemplates"
                   :options="filterTemplatesSelect"
                   @input="selected"
                   label="name"
                   placeholder="Select Filters"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    route: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    filterTemplate: '',
  }),
  computed: {
    ...mapState({
      filtersLoaded: state => state.guard.filtersLoaded,
      filterTemplates: state => state.clusterUsers.filterTemplates,
    }),
    filterTemplatesSelect() {
      return (
        this.filterTemplates &&
        this.filterTemplates.filter(
          filterTemplate => filterTemplate.filter_route.name === this.route,
        )
      );
    },
  },
  watch: {
    filtersLoaded: {
      immediate: true,
      handler() {
        if (this.filtersLoaded) {
          this.filterTemplate = this.filterTemplatesSelect.find(
            filterTemplate => filterTemplate.default === 1,
          );
          if (this.filterTemplate) {
            this.filterTemplate = this.filterTemplate.id;
            this.$emit('filterTemplatesInitialized', true);
            this.selected();
          } else {
            this.$emit('filterTemplatesInitialized', false);
          }
        }
      },
    },
  },
  methods: {
    selected() {
      if (this.filterTemplate) {
        const values = JSON.parse(
          this.filterTemplates.find(filterTemplate => filterTemplate.id === this.filterTemplate)
            .values,
        );
        if (typeof values === 'object' && values !== null) {
          Object.keys(values).forEach(key => {
            if (Array.isArray(values[key])) {
              values[key] = values[key].filter(n => n);
            }
          });
        }
        this.$emit('filterSelected', values);
      }
    },
  },
};
</script>

<style scoped>
.sort-button {
  & .simple-select-header {
    margin: 0;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadFilterDropdown.vue